import React from "react";

import BooleanSelector from "./BooleanSelector";

export default function AllowNullBNovaSelector(props) {
  return <BooleanSelector label="Permitir código Nova nulo" {...props} />;
}
